// frontend/geopolitikia/src/hooks/useChatHandler.js
import { useState, useCallback } from 'react';

const useChatHandler = (setLoading, resetActions, multiGameId = null) => {
  const [message, setMessage] = useState([]);
  const [actions, setActions] = useState([]);
  const [chatInputMessage, setChatInputMessage] = useState("");
  const [chatStatus, setChatStatus] = useState("");
  const [redirect, setRedirect] = useState("");

  const handleChat = useCallback(async (message, context = '') => {
    setLoading(true);
    setChatStatus("Analyse de votre demande...");
    setMessage("");
    setActions([]);

    try {
      const token = localStorage.getItem('jwtToken');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/chat`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ message, context, ...(multiGameId ? { game_id: multiGameId } : {}) })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";
      let actionsReceived = false;

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n\n');
        buffer = lines.pop();
        for (const line of lines) {
          if (line.startsWith('data: ')) {
            try {
              const dataStr = line.substring(6);
              if (dataStr) {
                const data = JSON.parse(dataStr);
                // Grouper les mises à jour liées en un seul cycle de rendu
                if (data.message) {
                  setMessage(data.message);
                  setChatStatus("");
                } else if (data.status) {
                  setChatStatus(data.status);
                }
                if (data.redirect) {
                  setRedirect(data.redirect);
                }
                if (data.actions) {
                  setActions(data.actions);
                  actionsReceived = true;
                  // Déverrouiller l'interface après réception des actions
                  setLoading(false);
                  resetActions();
                }
                if (data.error) {
                  console.error("Erreur IA stream :", data.error);
                  setChatStatus(`Erreur: ${data.error}`);
                  setLoading(false);
                  resetActions();
                }
              }
            }
            catch (e) {
              console.error("Failed to parse SSE data chunk:", line, e);
            }
          }
        }
      }

      // Si aucune action n'a été reçue, déverrouiller quand même
      if (!actionsReceived) {
        setLoading(false);
        resetActions();
      }
    }
    catch (error) {
      console.error("Erreur IA :", error);
      setChatStatus("Erreur de communication avec le serveur.");
      setLoading(false);
      resetActions();
    }
  }, [setLoading, setChatStatus, setMessage, setActions, resetActions, multiGameId]);

  return { message, setMessage, actions, setActions, chatInputMessage, setChatInputMessage, chatStatus, setChatStatus, handleChat, redirect };
};

export default useChatHandler;
